/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

// -----------------------------------------------------------------------------
// Greeting section configuration
//
// Replace the placeholder values below with your own information.  The
// `username` and `title` appear as the main heading on the landing page.  The
// `subTitle` uses the `emoji()` function to ensure emoji compatibility across
// browsers.  Leave `resumeLink` empty if you do not want to display a resume
// download button.  Set `displayGreeting` to false if you wish to hide the
// entire greeting section.
const greeting = {
  // Your full name as you want it to appear on the landing page
  username: "David Yesung Lee",

  // Greeting heading shown on the landing page
  title: "Hi there, I'm David Yesung Lee",

  // A short tagline about yourself.  The emoji() helper is used for cross
  // platform emoji support.  Feel free to rewrite this in your own words.
  subTitle: emoji(
    "Computer Science & Data Science student at Vanderbilt University passionate about artificial intelligence, data science and software engineering."
  ),

  // Link to your resume hosted online (Google Drive, Dropbox, etc.).  Leave
  // empty to hide the resume button.  Alternatively you can place your
  // resume in src/containers/greeting/resume.pdf and keep this empty.
  resumeLink: "",

  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  // Provide full URLs to your social profiles below.  Any platform left
  // as an empty string will not be displayed.
  github: "", // Add your GitHub profile URL if you wish to display it
  linkedin: "https://www.linkedin.com/in/david-yesung-lee/",
  gmail: "david.yesung.lee@gmail.com",
  gitlab: "",
  facebook: "",
  medium: "",
  stackoverflow: "",
  twitter: "",
  instagram: "",
  kaggle: "",
  display: true
};

// Skills Section

const skillsSection = {
  title: "Technical Skills",
  subTitle:
    "Versatile developer and data scientist with a passion for AI, machine learning and cloud computing",
  skills: [
    emoji("⚡ Experienced with Java, Python, R, HTML, CSS and JavaScript"),
    emoji(
      "⚡ Comfortable working with agile and waterfall methodologies, CI/CD pipelines and version control with Git"
    ),
    emoji(
      "⚡ Skilled in data science techniques such as regression models, cross validation, random forests and data visualisation"
    ),
    emoji(
      "⚡ Strong understanding of cloud computing and machine learning concepts"
    )
  ],
  /* Make sure to include the correct Font Awesome classname to view your icon
  https://fontawesome.com/icons?d=gallery */
  softwareSkills: [
    {skillName: "HTML5", fontAwesomeClassname: "fab fa-html5"},
    {skillName: "CSS3", fontAwesomeClassname: "fab fa-css3-alt"},
    {skillName: "JavaScript", fontAwesomeClassname: "fab fa-js"},
    {skillName: "Python", fontAwesomeClassname: "fab fa-python"},
    {skillName: "Java", fontAwesomeClassname: "fab fa-java"},
    {skillName: "R", fontAwesomeClassname: "fas fa-chart-bar"},
    {skillName: "Git", fontAwesomeClassname: "fab fa-git"},
    {skillName: "Agile", fontAwesomeClassname: "fas fa-tasks"},
    {skillName: "Machine Learning", fontAwesomeClassname: "fas fa-brain"}
  ],
  display: true
};

// Education Section

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Vanderbilt University",
      // Replace with your university's logo image if available
      // Use the Vanderbilt University logo stored in src/assets/images/vanderbiltLogo.png.  Replace this file with an
      // official logo if you have one.
      logo: require("./assets/images/vanderbiltLogo.png"),
      subHeader: "Bachelor of Engineering in Computer Science and Bachelor of Science in Human and Organizational Development",
      duration: "August 2023 – May 2027",
      desc: "GPA: 3.825. Double major in Computer Science and Human and Organizational Development with a minor in Data Science.",
      descBullets: [
        "Completed coursework in Data Structures, Program Design, Discrete Structures, Java Programming, Statistical Analysis, and Research Design",
        "Studied economics, digital history, public policy and organization management to develop interdisciplinary skills"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true,
  // Relative proficiency levels across different domains.  Adjust these
  // percentages to reflect your strengths.
  experience: [
    {Stack: "Programming", progressPercentage: "85%"},
    {Stack: "Data Science", progressPercentage: "80%"},
    {Stack: "Software Engineering", progressPercentage: "75%"}
  ],
  displayCodersrank: false
};

// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Freelance Web Developer",
      company: "Joy Cleaners",
      date: "January 2024 – Present",
      desc: "Developed and maintained custom websites for local businesses, focusing on user experience and modern web technologies.",
      descBullets: [
        "Designed responsive websites using HTML, CSS, and JavaScript to meet client specifications and improve online presence",
        "Collaborated with clients to understand business needs and translate requirements into functional web solutions"
      ]
    },
    {
      role: "Freelance Web Developer",
      company: "Hanshin Church",
      date: "March 2024 – Present",
      desc: "Created and maintained church website, implementing modern web development practices and ensuring accessibility standards.",
      descBullets: [
        "Built responsive church website with modern UI/UX design principles and mobile-first approach",
        "Integrated content management features and maintained website performance and security"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  // Set to "true" to show your GitHub profile card in the contact section.  This
  // requires USE_GITHUB_DATA = "true" and a valid token in .env.
  showGithubProfile: "false",
  // Hide the open source section when not pulling data from GitHub
  display: false
};

// Some big projects you have worked on

const bigProjects = {
  title: "Personal Projects",
  subtitle: "Some of the projects I've worked on",
  projects: [
    {
      projectName: "Nintendo Switch Automation",
      projectDesc:
        "Built an Arduino‑based automation system for Nintendo Switch games, integrating microcontrollers, capture cards and PC‑based software to automate gameplay and optimise RNG probability.",
      footerLink: [
        {
          name: "Learn More",
          url: "https://github.com/PokemonAutomation"
        }
      ]
    },
    {
      projectName: "Recruiter AI Assistant",
      projectDesc:
        "Developed an AI-powered recruitment assistant using machine learning and natural language processing to streamline the hiring process and improve candidate matching.",
      footerLink: [
        {
          name: "Learn More",
          url: "https://recruiterai.pro/"
        }
      ]
    }
  ],
  display: true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements 🏆"),
  subtitle: "Highlights of my academic and extracurricular achievements.",
  achievementsCards: [
    {
      title: "Academic Excellence",
      subtitle:
        "Maintained a GPA of 3.979 while pursuing a dual major in Computer Science and Data Science at Vanderbilt University.",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "Academic Excellence",
      footerLink: []
    }
  ],
  // Hide the achievements section entirely.  Set to true if you add achievements later.
  display: false
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle: "I enjoy sharing what I learn by writing articles and tutorials.",
  // Set to true to display Medium blogs (requires MEDIUM_USERNAME in .env)
  displayMediumBlogs: "false",
  // List of manually added blog posts (leave empty or remove if not used)
  blogs: [],
  display: false
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1-615-423-4898",
  email_address: "david.yesung.lee@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "", // Replace with your Twitter username without @ if you want to display this section
  display: false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
